import { motion } from "framer-motion";

const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_008705cc-4791-46f2-aff2-0741ecdfeee7/artifacts/wav2a4qw_Hands-on%20coding%20with%20robotics%20.png",
    alt: "Kids gathered around a robotics project",
    caption: "Hands-on coding with robotics kits",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_008705cc-4791-46f2-aff2-0741ecdfeee7/artifacts/3uwxgjb9_Building%20projects.png",
    alt: "Boy holding a diploma and gift certificate",
    caption: "Building projects they're proud of",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_008705cc-4791-46f2-aff2-0741ecdfeee7/artifacts/03sczc8f_Collaborative%20team%20projects.png",
    alt: "Boys collaborating on a board game project",
    caption: "Collaborative team projects",
  },
  {
    src: "https://images.unsplash.com/photo-1758612897668-ce0c153745e4?w=600&h=400&fit=crop&auto=format",
    alt: "Young boy using a tablet for learning",
    caption: "Interactive digital learning",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_008705cc-4791-46f2-aff2-0741ecdfeee7/artifacts/ia7047j4_Small%20group%20instruction.png",
    alt: "Students writing at desks in a classroom",
    caption: "Small group instruction",
  },
];

export const GalleryMasonry = () => {
  return (
    <section data-testid="gallery-section" className="pt-[35px] pb-[35px] md:py-24 bg-white">
      <div className="mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold bg-[#E7FFF6] text-[#00A676] mb-4">
            Gallery
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-4">
            See How{" "}
            <span className="text-[#00A676]">Classes Work</span>
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto">
            Take a peek inside our classrooms where creativity, coding, and collaboration meet.
          </p>
        </motion.div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {/* Large featured image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="col-span-2 row-span-2 gallery-item rounded-2xl overflow-hidden relative group"
            data-testid="gallery-item-0"
          >
            <img
              src={GALLERY_IMAGES[0].src}
              alt={GALLERY_IMAGES[0].alt}
              className="w-full h-full min-h-[300px] md:min-h-[420px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
              <p className="text-white text-sm font-semibold">{GALLERY_IMAGES[0].caption}</p>
            </div>
          </motion.div>

          {/* Smaller images */}
          {GALLERY_IMAGES.slice(1).map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: (i + 1) * 0.1 }}
              className="gallery-item rounded-2xl overflow-hidden relative group"
              data-testid={`gallery-item-${i + 1}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-[180px] md:h-[200px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <p className="text-white text-xs font-semibold">{img.caption}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryMasonry;
